import { render, staticRenderFns } from "./LessonProccessSettingModeDefault.vue?vue&type=template&id=b568a0a8&scoped=true&lang=pug&"
import script from "./LessonProccessSettingModeDefault.vue?vue&type=script&lang=ts&"
export * from "./LessonProccessSettingModeDefault.vue?vue&type=script&lang=ts&"
import style0 from "./LessonProccessSettingModeDefault.vue?vue&type=style&index=0&id=b568a0a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568a0a8",
  null
  
)

export default component.exports